import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';
import { components, contentfulUtils } from '@glowforge/ui-common';
import { getValueFromCountryCode } from 'app/common/containers/country-code';

import './message-banner.less';

const { Markdown, reactUtils: { includeWhen } } = components;

const { stringSubstitution } = contentfulUtils;

/**
 * Helpers to render the content body for the message banner
 */
export const ContentBody = ({
  markdownSource,
  textClassName,
  photoUrl,
}) => (
  <React.Fragment>
    {includeWhen(photoUrl, () => (
      <div className='image-wrapper'>
        <div className='image' style={{ backgroundImage: `url(${photoUrl})` }} />
      </div>
    ))}
    <Markdown className={classnames('message', textClassName)} source={markdownSource} />
  </React.Fragment>
);

ContentBody.propTypes = {
  markdownSource: PropTypes.string.isRequired,
  textClassName: PropTypes.string.isRequired,
  photoUrl: PropTypes.string.isRequired,
};

export const ReferralFragment = ({
  isAffiliate,
  referralInfo,
  products,
  strings,
}) => {
  const textKey = isAffiliate ? 'referral-banner-affiliate-text' : 'referral-banner-non-affiliate-text';
  const stringSubText = stringSubstitution(strings[textKey], {
    name: `<span class='name'>${_.get(referralInfo, 'referredByName')}</span>`,
    proDiscount: _.get(products, 'pro.referral.payment'),
    plusDiscount: _.get(products, 'plus.referral.payment'),
    basicDiscount: _.get(products, 'basic.referral.payment'),
  });
  const { photoUrl } = referralInfo;
  return (
    <ContentBody
      markdownSource={stringSubText}
      photoUrl={photoUrl}
      textClassName='referral-text' />
  );
};

ReferralFragment.propTypes = {
  isAffiliate: PropTypes.bool.isRequired,
  referralInfo: PropTypes.shape({}).isRequired,
  products: PropTypes.shape({}).isRequired,
  strings: PropTypes.arrayOf({}).isRequired,
};

export const AnnouncementFragment = ({
  announcement,
  countryCode,
  sections,
}) => {
  // getValueFromCountryCode expects an object with entries of { id: url }
  const urlHash = _.chain(sections)
    .keyBy('fields.id')
    .mapValues('fields.media.fields.file.url')
    .value();
  const iconUrl = getValueFromCountryCode('announcement-icon', countryCode, urlHash);

  return (
    <ContentBody
      markdownSource={announcement}
      photoUrl={iconUrl} />
  );
};

AnnouncementFragment.propTypes = {
  announcement: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  sections: PropTypes.arrayOf({}).isRequired,
};



// WEBPACK FOOTER //
// ./app/components/landing/message-banner/content-body.jsx